import styled from "styled-components";

export const BackButton = styled.button<{ $isRTL: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${({ theme }) => theme.colors.secondary};
  transition: all 0.3s ease;
  padding: 0.5rem;

  &:hover {
    opacity: 0.8;
    transform: translateX(${props => props.$isRTL ? '10px' : '-10px'});
  }

  /* Flip arrow in RTL mode */
  ${props => props.$isRTL && `
    flex-direction: row-reverse;
    svg {
      transform: rotate(180deg);
    }
  `}
`; 